export default __webpack_public_path__ + "static/media/cage_circle.ba39dd7e.svg";